import { render } from "./OrganizationLogin.vue?vue&type=template&id=4b1b42d4&lang=pug"
import script from "./OrganizationLogin.vue?vue&type=script&lang=js"
export * from "./OrganizationLogin.vue?vue&type=script&lang=js"

import "./OrganizationLogin.vue?vue&type=style&index=0&id=4b1b42d4&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__